/* eslint-disable prettier/prettier */
import { Column, Entity, JoinColumn, ManyToOne, PrimaryColumn } from 'typeorm';
import { Activite, Fichier } from '.';

@Entity('image')
export default class Images {
    @PrimaryColumn()
    fk_id_fichier: number;

    @PrimaryColumn()
    fk_id_activite: number;

    @ManyToOne(() => Activite, (activite) => activite.id, { eager: true })
    @JoinColumn({ name: 'fk_id_activite' })
    activites: Activite;

    @ManyToOne(() => Fichier, (fichier) => fichier.id, { eager: true })
    @JoinColumn({ name: 'fk_id_fichier' })
    fichiers: Fichier;

    @Column({ nullable: true })
    ordre_affichage: number;

    @Column({ nullable: true })
    ignorer: boolean;
}
